<template>
    <div class="wrapper">
        <h1 class="crumb">公告列表</h1>
        <button style="width: 100px;height: 35px;font-size: 16px;border: 0;cursor: pointer; color: #ffffff;background: #f56c31;border-radius: 2px;" @click="addInquiry">添加公告</button>
        <el-table
            :data="tableData"
            style="width: 100%;margin-top: 20px;">
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column prop="content" label="内容" align="center"></el-table-column>
            <el-table-column prop="addtime" label="添加日期" width="100" align="center" :formatter="formatter"></el-table-column>
            <el-table-column prop="update_time" label="修改日期" width="100" align="center" :formatter="formatters"></el-table-column>
            <el-table-column  label="操作" align="center" width="130">
            <template slot-scope="props">
                <a @click="Edit(props.row)">编辑</a><span> | </span>
                <a @click="Delete(props.row)">删除</a>
            </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
        <!--修改商品信息-->
        <el-dialog title="添加公告" :visible.sync="EditShop" width="500px">
            <el-form :model="editForm">
                <el-form-item label="标题:" :label-width="formLabelWidth">
                    <el-input v-model="editForm.title" > </el-input>
                </el-form-item>
                <el-form-item label="内容:" :label-width="formLabelWidth">
                    <el-input v-model="editForm.content"> </el-input>
                </el-form-item>
                <el-form-item label="经销商:" :label-width="formLabelWidth">
                    <el-select v-model="editForm.user_ids" multiple collapse-tags placeholder="请选择" style="width: 100%">
                        <el-option
                            v-for="item in supplyList"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditShop = false">取 消</el-button>
                <el-button type="primary" @click="addAddr" :loading="isLoad">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑公告" :visible.sync="addShop" width="500px">
            <el-form :model="addForm">
                <el-form-item label="标题:" :label-width="formLabelWidth">
                    <el-input v-model="addForm.title" > </el-input>
                </el-form-item>
                <el-form-item label="内容:" :label-width="formLabelWidth">
                    <el-input v-model="addForm.content"> </el-input>
                </el-form-item>
                <el-form-item label="经销商:" :label-width="formLabelWidth">
                    <el-select v-model="addForm.user_ids" multiple collapse-tags placeholder="请选择" style="width: 100%">
                        <el-option
                            v-for="item in supplyList"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addShop = false">取 消</el-button>
                <el-button type="primary" @click="editAddr" :loading="isLoad">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import qs from 'qs'
    export default {
        data() {
            return {
                page: 1,
                isLoad: false,
                total: '',
                tableData: [],
                editForm: {
                    title: '',
                    content: '',
                    user_ids: '',
                },
                addForm: {},
                addShop: false,
                supplyList: [],
                EditShop: false,
                formLabelWidth: '100px',
            }
        },
        created () {
            this.getInqueryList()
            this.getSuppleList()
        },
        methods: {
            formatter(row, column) {
                return new Date(Number(row.addtime * 1000)).toLocaleDateString().replace(/\//g, "-")
            },
            formatters(row, column) {
                if (row.update_time === '' || row.update_time === '0') {
                    return ''
                }
                return new Date(Number(row.update_time * 1000)).toLocaleDateString().replace(/\//g, "-")
            },
            getSuppleList () {
                this.$http.get(this.$reqUrl + `user.php?act=users_list`).then(res => {
                    this.supplyList = res.data.data
                })
            },
            getInqueryList () {
                let temp = {}
                temp.page = this.page
               this.$http.get(this.$reqUrl + `user.php?act=dealer_bulletin_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                   if (res.data.error === 0) {
                       this.tableData = res.data.data
                       this.total = res.data.pagecount
                   } else {
                       this.$message.error('加载失败')
                   }
               })
            },
            //添加公告
            addAddr () {
                if (this.editForm.title && this.editForm.content && this.editForm.user_ids) {
                    this.isLoad = true
                this.$http.post(this.$reqUrl + `user.php?act=post_dealer_bulletin&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(this.editForm)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.isLoad = false
                        this.EditShop = false
                        this.editForm = {title: '', content: '', user_ids: ''}
                        this.getInqueryList()
                    } else {
                        this.isLoad = false
                        this.$message.error('操作失败')
                    }
                })
                } else {
                    this.$message.error('请完善信息')
                }
            },
            //编辑公告
            Edit (row) {
                this.addShop = true
                this.addForm = row
                if (this.addForm.user_ids !== '') {
                    this.addForm.user_ids = row.user_ids.split(',')
                } else {
                    this.addForm.user_ids = []
                }

            },
            editAddr() {
                this.isLoad = true
                let data = {
                    title: this.addForm.title,
                    content: this.addForm.content,
                    user_ids: this.addForm.user_ids,
                    dealer_id: this.addForm.dealer_id
                }
                this.$http.post(this.$reqUrl + `user.php?act=post_dealer_bulletin&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.isLoad = false
                        this.addShop = false
                        this.getInqueryList()
                    } else {
                        this.isLoad = false
                        this.$message.error('操作失败')
                    }
                })
            },
            //删除公告
            Delete (row) {
                this.$alert('确定删除该广告?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=del_dealer_bulletin&session_id=${localStorage.getItem('shouhou_session_id')}&dealer_id=${row.dealer_id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('删除成功')
                            this.getInqueryList()
                        }
                    })
                }).catch(() => {
                    console.log('s')
                })
            },
            //点击换页
            handleCurrentChange (val) {
                this.page = val
                this.getInqueryList()
            },
            //跳转添加询价单界面
            addInquiry () {
                this.EditShop = true
            },
        }
    }
</script>
<style lang="less" scoped>
    .wrapper{
        .edit-button{
            padding: 8px 15px;
            border: 0;
            background: white;
            color: #f56c31 ;
            border: 1px solid #f56c31;
        }
    }
</style>
<style>
    .el-table th>.cell{
        color: #f56c31;
    }
</style>



// WEBPACK FOOTER //
// src/router/Announcement.vue